import { Route } from 'react-router';
import { useRouteMatch } from 'react-router-dom';
import { Routes } from '../constants/routes';
import History from './history';
import Rules from './rules';
import SkillOrChance from './skillOrChance';
import StrategyTips from './strategyTips';
import BaseHelpContent from '@base/features/help/components/baseHelpContent';

function HelpContent() {
  const { path } = useRouteMatch();

  return (
    <BaseHelpContent>
      <Route exact path={path + '/' + Routes.RULES}>
        <Rules />
      </Route>
      <Route exact path={path + '/' + Routes.SKILL_OR_CHANCE}>
        <SkillOrChance />
      </Route>
      <Route exact path={path + '/' + Routes.STRATEGY_TIPS}>
        <StrategyTips />
      </Route>
      <Route exact path={path + '/' + Routes.HISTORY}>
        <History />
      </Route>
    </BaseHelpContent>
  );
}

export default HelpContent;
